import { Link } from 'react-router-dom';

export default function Kontakt(props) {
  return (
    <div id="kontakt">
      <h2>Schön Dich kennenzulernen, {props.prename}. Wie lautet Deine E-Mail-Adresse?</h2>
      <div className="ccontent">
        <label htmlFor="email">E-Mail</label>
        <input type="text" name="email" size="15" placeholder="E-Mail" onChange={(e) => props.setEmail(e.target.value)}></input>
      </div>
      { props.email && <Link className="ui button" to='/anliegen'>Weiter</Link> }
      { !props.email && <Link className="ui button disabled">Weiter</Link> }
    </div>
  )
}